import styled from 'styled-components';

// Captcha styles
export const CaptchaContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  width: 100%;
`;
export const CaptchaError = styled.div`
  color: #d32f2f;
  font-size: 1.25rem;
  margin-top: 0.75rem;
  text-align: center;
`;
